module.exports = __webpack_public_path__ + "img/rabbit.b12d64fb.png";